import {
  Inject,
  Injectable,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Resolve } from '@angular/router';

@Injectable()
export class ISLChatbotScriptResolver implements Resolve<boolean> {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadExternalScript(url: string) {
    if (this.document.querySelector(`script[src="${url}"]`)) {
      return Promise.resolve(true);
    }

    return new Promise<void>((resolve, reject) => {
      const scriptElm: HTMLScriptElement =
        this.renderer.createElement('script');

      scriptElm.src = url;
      scriptElm.defer = true;

      if (isPlatformServer(this.platformId)) {
        resolve();
      } else {
        scriptElm.onload = () => resolve();
        scriptElm.onerror = () => resolve();
      }

      this.renderer.appendChild(this.document.body, scriptElm);
    });
  }

  resolve(): Promise<boolean> {
    return Promise.all([
      this.loadExternalScript(
        'https://islai.amritacreate.org/static/am-islchat-sdkloader.js'
      ),
      this.loadExternalScript('scripts/isl-chatbot.js'),
    ]).then(() => true);
  }
}
